import { getEditorStateFromHtml } from '../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/utils'
import { getUserDisplayName } from '../../apps/professional-app/fa/common/aifeatures/utils'

import { Task } from '../../models/MeetingSupport'
import { User } from '../../models/User'

export const zocksUserToSelectOption = (user: User) => {
  return {
    id: user.id,
    label: getUserDisplayName(user),
  }
}

export const getLexicalValue = (task: Task) => {
  const { task: subject, description } = task
  const descriptionHtmlValue = description ? `: ${description}` : ''
  const htmlValue = `<p><strong>${subject}</strong>${descriptionHtmlValue}</p>`
  const editorState = getEditorStateFromHtml(htmlValue).toJSON()
  return JSON.stringify(editorState)
}
